import { createContext } from "react";
export var MessageContext = createContext(null);
